/**
 * Whether a vendor account can be created from this sponsor. The vendor side joins the
 * sponsor's HyperComply organization, so a dual-role sponsor (already paired) and a VQA only
 * sponsor (no organization) are left out.
 * @param {{ sponsor_id?: string, isdual_role?: boolean, is_vqa_only?: boolean } | null | undefined} sponsor
 */
export function canCreateVendorAccountFromSponsor(sponsor) {
  return Boolean(sponsor?.sponsor_id) && !sponsor?.isdual_role && !sponsor?.is_vqa_only;
}
